import { User } from "../../types/User";

import Typography from "@mui/material/Typography";
import React from "react";
import { useNavigate } from "react-router-dom";

interface UserNameProps {
    user: User;
}

const UserName: React.FC<UserNameProps> = ({ user }) => {
    const navigate = useNavigate();

    function handleClick(event: React.MouseEvent<HTMLDivElement>) {
        event.preventDefault();
        event.stopPropagation();
        navigate(`/user/${user.id}`);
    }

    return (
        <Typography onClick={handleClick} onMouseDown={(e) => e.stopPropagation()} display={"inline"}>
            {user.username}
        </Typography>
    );
};

export default UserName;
